const hasAncestor = (el, test) => {
    if (!el) {
        return false;
    }
    if (test(el)) {
        return true;
    }
    return hasAncestor(el.parentElement, test);
};

export default hasAncestor;



// WEBPACK FOOTER //
// ./src/js/hasAncestor.js